module.exports = __webpack_public_path__ + "static/img/movimento_ods_logo.c4acc84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/logo/movimento_ods_logo.jpg
// module id = xuae
// module chunks = 15